import { useQuery } from '@tanstack/react-query';
import * as messageLogApi from '../api/messageLog';
import type { GuestMessageLogFilters } from '../api/messageLog';

export function useGuestMessages(filters: GuestMessageLogFilters, enabled = true) {
  return useQuery({
    queryKey: ['guest-messages', filters],
    queryFn: () => messageLogApi.getGuestMessages(filters),
    // Needs a scope; the endpoint rejects an unscoped query outright.
    enabled: enabled && !!(filters.eventId || filters.guestId),
  });
}

export function useGuestMessageTemplates(eventId?: string) {
  return useQuery({
    queryKey: ['guest-message-templates', eventId],
    queryFn: () => messageLogApi.getGuestMessageTemplates(eventId!),
    enabled: !!eventId,
  });
}
